/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamRunStateResponse } from './oralExamRunStateResponse';

export type GenericApiResponseOralExamRunStateResponseData = OralExamRunStateResponse | null;
